<template>
  <div class="tabar">
    <ul>
      <li
        v-for="(item,index) in tabList"
        :key="index"
        @click="switchTo(item.path)"
        :class="{ active: item.path == $route.path }"
      >
        <img :src="item.path == $route.path ? item.icon_active : item.icon " alt  class="z-index:100;"/>
        {{item.title}}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "tabar",
  data(){
    return{
      tabList: [
        {
          title: "康养中心",
          path: "/#",
          icon: require("@/assets/images/home-img/9.png"),
          icon_active: require("@/assets/images/home-img/2.png")
        },
        {
          title: "营销中心",
          path: "/",
          icon: require("@/assets/images/home-img/7.png"),
          icon_active: require("@/assets/images/home-img/6.png")
        },
        {
          title: "个人中心",
          path: "/my",
          icon: require("@/assets/images/home-img/1.png"),
          icon_active: require("@/assets/images/home-img/8.png")
        },
      ]
    }
  },
  components:{
  },
  methods:{
    switchTo(path) {
      // console.log(path)
      if(path == this.$route.path){
        return
      }else if(path == '/#'){
        window.location.href = "http://minsu.kfm666666.net/";
        // alert('暂未开通');
      }
      this.$router.replace(`${path}`);
    }

  }
}
</script>
<style lang="less" scoped>
  .tabar {
    width: 100%;
    height: .98rem;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    box-shadow: 0rem 0rem 0.05rem 0rem #ececec;
    -webkit-box-shadow: 0rem 0rem 0.05rem 0rem #ececec;
    *{
      border:0;
    }
    ul {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      background: #fff;
      justify-content: space-around;
      // &::after {
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 1px;
      //   background: #999;
      // }
    }
    li {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: 0.22rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #B7B7B7;;
      img {
        width: .42rem;
        height: .42rem;
        margin: 5px 0;
      }
      &.active {
        color: #EF8201;
        font-weight: 600;
        font-size: 0.22rem;
        font-family: PingFang SC;
      }
    }
  }
</style>